import { history } from 'store';

export function pushTo(route: string, props?: any) {
  history.push(route, props);
}
